module.exports = __webpack_public_path__ + "media/images/flags/mv-356e730e2b87670b84e6468cd69134a9.svg";